<template>
  <div class="lifeguard">
    <div class="bread"><router-link to="/">数据大屏</router-link> > <span>救生员执勤概况</span></div>
    <div class="title">
      <div class="left">
        <div class="name">救生员执勤概况</div>
        <div class="legend">
          <div class="item">
            <div class="icon" style="background: #FE9829;"></div>
            <div class="name">缺岗</div>
          </div>
          <div class="item">
            <div class="icon" style="background: #6236FF;"></div>
            <div class="name">顶岗</div>
          </div>
          <div class="item">
            <div class="icon" style="background: #FF4E29;"></div>
            <div class="name">状态不佳</div>
          </div>
          <div class="item">
            <div class="icon" style="background: #FFC127;"></div>
            <div class="name">超时</div>
          </div>
          <!-- <div class="item" v-for="(item, index) in guards" :key="index">
            <div class="icon" :style="'background: ' + colors[index] + ';'"></div>
            <div class="name">{{ item }}</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="list" v-if="series.length">
      <div class="item" v-for="(item, index) in series" :key="index">
        <div class="num">{{ item.info.name }}</div>
        <div class="avatar">
          <img src="../../assets/xuhui/avatar.png" />
        </div>
        <!-- <div class="name">岗位.{{ item.position }}</div> -->
        <div class="chart-area">
          <time-chart :colors="colors" :date="date" :series="item.data"></time-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeChart from '../../components/time-chart.vue'
import moment from 'moment'

export default {
  components: { TimeChart },
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      colors: [
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
        '#30C2F9',
      ],
      guards: [],
      series: [],
    }
  },
  mounted() {
    this.get_data()
  },
  methods: {
    get_data() {
      this.$http({
        url: 'api/timeline-guards',
        method: 'get',
        params: {
          pool_id: this.$route.query.pool_id,
          date: this.date,
        },
      }).then((r) => {
        this.guards = r.guards
        this.series = r.series
      })
    },
  },
}
</script>

<style lang="less" scoped>
.lifeguard {
  min-height: 100vh;
  background: #002146;
  padding: 50px 40px 0;
  .bread {
    color: #fff;
    font-size: 28px;
    a {
      margin-right: 12px;
      color: #fff;
    }
    span {
      margin-left: 12px;
    }
  }
  .title {
    font-size: 30px;
    color: #32c5ff;
    padding: 16px 0 40px;
    .left {
      .legend {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .item {
          display: flex;
          align-items: center;
          .icon {
            width: 20px;
            height: 20px;
            border-radius: 6px;
            margin-right: 15px;
          }
          .name {
            font-size: 20px;
            color: #ffffff;
          }
          & + .item {
            margin-left: 60px;
          }
        }
      }
    }
  }
  .list {
    padding-bottom: 120px;
    .item {
      height: 118px;
      background: #093160;
      box-shadow: 0px 4px 12px 0px rgba(0, 33, 70, 1);
      border-radius: 6px;
      color: #fff;
      display: flex;
      align-items: center;
      padding: 0px 20px;
      & + .item {
        margin-top: 20px;
      }
      .num {
        font-size: 24px;
        color: #ffffff;
        width: 90px;
      }
      .avatar {
        width: 50px;
        height: 50px;
        margin: 0 30px 0 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .chart-area {
        width: 1200px;
        margin-left: 30px;
        // margin-top: 20px;
        // margin-bottom: 20px;
        // background: #002146;
      }
    }
  }
}
</style>
